import { createIcon } from './create-icon';

export const RefreshIcon = createIcon(
  'RefreshIcon',
  <>
    <path d="M1 4v6h6" />
    <path d="M23 20v-6h-6" />
    <path d="M20.49 9A9 9 0 005.64 5.64L1 10M23 14l-4.64 4.36A9 9 0 013.51 15" />
  </>,
);
